module.exports = __webpack_public_path__ + "static/media/top5-buenos-aires.e8860254.md";